import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeliveryNoteSettingsDto } from '@dto/deliveryNoteSettingsDto';
import { UserDto } from '@dto/userDto';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomersService } from '@services/entity/customers.service';
import { DeliveryNotesService } from '@services/entity/delivery-notes.service';
import { UsersService } from '@services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-delivery-notes-settings-dialog-content',
  templateUrl: './edit-delivery-notes-settings-dialog-content.component.html',
  styleUrls: ['./edit-delivery-notes-settings-dialog-content.component.scss'],
})
export class EditDeliveryNotesSettingsDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'EditDeliveryNotesSettingsDialogContentComponent';

  public deliveryNoteSettings: DeliveryNoteSettingsDto;

  public fileName: string = ""
  public fileNameExample: any = {}

  public isUser: boolean = false
  public isCustomer: boolean = false
  public isOperator: boolean = false
  public isSupporter: boolean = false;
  public customerId: number

  constructor(
    public activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute,
    public dialog: NgbModal,
    private deliveryNotesService: DeliveryNotesService,
    public customersService: CustomersService,
    public toastService: ToastService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  ngOnInit() {
    this.getRoles();
    
    if (this.isOperator) {
      this.customerId = this.activatedRoute.children[0].snapshot.params.key;
    } else {
      this.customerId = Number(localStorage.getItem('customerId'));
    }
    
    if (this.customerId == null) {
      this.toastService.error("Fehler beim Aufruf der Lieferscheineinstellungen")
      this.activeModal.close();
    }

    this.setupExample()
    this.getDeliveryNotesSettings()
    super.ngOnInit()
  }
  
  setupExample() {
    this.fileNameExample.sequentialNumber = '123'
    this.fileNameExample.recipientFirstName = 'Max'
    this.fileNameExample.recipientLastName = 'Mustermann'
    this.fileNameExample.createdMonth = new Date().getMonth().toString()
    this.fileNameExample.createdYear = new Date().getFullYear().toString()
  }

  getDeliveryNotesSettings() {
    this.deliveryNotesService.getDeliveryNoteSettings(this.customerId).subscribe(deliveryNoteSettings => {
      this.deliveryNoteSettings = plainToClass(DeliveryNoteSettingsDto, deliveryNoteSettings)
      this.setFileName()
    }, error => {
      this.deliveryNotesService.createDeliveryNoteSettings(this.customerId).subscribe(deliveryNoteSettings => {
        this.deliveryNoteSettings = deliveryNoteSettings
        this.setFileName()
      })
    })
  }

  toggleFileNameVariable(variable, value) {
    if (this[variable] != '') this[variable] = value
    else this[variable] = ''
    this.setFileName()
  }

  setFileName() {
    let variable = this.fileNameExample[this.deliveryNoteSettings.fileNameFirstVariable]
    this.fileName = variable.replace(/ /g, '_')

    if (this.deliveryNoteSettings.fileNameSecondVariable) {
      let variable = this.fileNameExample[this.deliveryNoteSettings.fileNameSecondVariable]
      this.fileName += `_${variable.replace(/ /g, '_')}`
    }

    if (this.deliveryNoteSettings.fileNameThirdVariable) {
      let variable = this.fileNameExample[this.deliveryNoteSettings.fileNameThirdVariable]
      this.fileName += `_${variable.replace(/ /g, '_')}`
    }

    this.fileName += '.pdf'
  }

  isDate(value: string) {
    if (!value || typeof value != 'string') return false
    return new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z*/).test(value.trim())
  }

  parseDate(date: Date) {
    date = new Date(date)
    const y = date.getFullYear()
    const m = date.getMonth()
    const d = date.getDate()
    return `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d}`
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
  }

  saveAndClose() {
    this.deliveryNotesService.patchDeliveryNoteSettings(this.customerId, this.deliveryNoteSettings).subscribe(deliveryNoteSettings => {
      this.deliveryNoteSettings = plainToClass(DeliveryNoteSettingsDto, deliveryNoteSettings)
      this.setFileName()
      this.toastService.success('Lieferscheineinstellungen erfolgreich gespeichert.')
      this.close()
    }, error => {
      console.error(error)
      this.toastService.error('Fehler beim Speichern der Lieferscheineinstellungen.')
    })
  }

  close() {
    this.activeModal.close();
  }
}
